import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 w-full glass-header z-50">
        <div className="max-w-container-max mx-auto px-margin-page py-4 flex justify-between items-center">
            <a href="/" target="_blank" rel="noreferrer" className="font-headline font-bold tracking-tight text-primary text-xl">DINESHKUMAR</a>
            <nav className="hidden md:flex items-center gap-8">
                <Link className="text-on-surface-variant hover:text-primary transition-colors text-label-md font-medium"
                    to="/experience">Experience</Link>
                <Link className="text-on-surface-variant hover:text-primary transition-colors text-label-md font-medium"
                    to="/projects">Projects</Link>
               
                <Link className="text-on-surface-variant hover:text-primary transition-colors text-label-md font-medium"
                    to="/ai">AI &amp; Innovation</Link>
                <Link className="text-on-surface-variant hover:text-primary transition-colors text-label-md font-medium"
                    to="/about">About Dinesh</Link>
                <Link className="text-on-surface-variant hover:text-primary transition-colors text-label-md font-medium"
                    to="/contact">Contact</Link>
                <Link className="text-on-surface-variant hover:text-primary transition-colors text-label-md font-medium"
                    to="/blog">Blog</Link>
            </nav>
            <div className="flex items-center gap-4">
                <a href="mailto:dineshnataraj345@outlook.com"
                    className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary text-on-primary font-semibold text-sm hover:bg-primary/90 transition-all active:scale-95">
                    <span className="material-symbols-outlined text-[18px]">terminal</span>
                    Contact Me
                </a>
                <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-primary">
                    <span className="material-symbols-outlined">{isMenuOpen ? 'close' : 'menu'}</span>
                </button>
            </div>
        </div>
        {isMenuOpen && (
            <div className="md:hidden absolute top-full left-0 w-full bg-[#0a0e1a] border-b border-primary/20 flex flex-col p-4 shadow-2xl">
                <Link onClick={() => setIsMenuOpen(false)} className="py-3 px-4 text-on-surface-variant hover:bg-primary/10 hover:text-primary transition-colors text-label-md font-medium rounded-lg" to="/experience">Experience</Link>
                <Link onClick={() => setIsMenuOpen(false)} className="py-3 px-4 text-on-surface-variant hover:bg-primary/10 hover:text-primary transition-colors text-label-md font-medium rounded-lg" to="/projects">Projects</Link>
                <Link onClick={() => setIsMenuOpen(false)} className="py-3 px-4 text-on-surface-variant hover:bg-primary/10 hover:text-primary transition-colors text-label-md font-medium rounded-lg" to="/skills">Skills</Link>
                <Link onClick={() => setIsMenuOpen(false)} className="py-3 px-4 text-on-surface-variant hover:bg-primary/10 hover:text-primary transition-colors text-label-md font-medium rounded-lg" to="/ai">AI &amp; Innovation</Link>
                <Link onClick={() => setIsMenuOpen(false)} className="py-3 px-4 text-on-surface-variant hover:bg-primary/10 hover:text-primary transition-colors text-label-md font-medium rounded-lg" to="/about">About Dinesh</Link>
                <Link onClick={() => setIsMenuOpen(false)} className="py-3 px-4 text-on-surface-variant hover:bg-primary/10 hover:text-primary transition-colors text-label-md font-medium rounded-lg" to="/blog">Blog</Link>
            </div>
        )}
    </header>
  );
};

export default Header;
